import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_ACCESS} from '../../constants';

export default {
  id: 'MDP',
  title: 'Comment modifier mon mot de passe ?',
  description: '',
  categories: [CONTENT_CATEGORY_ACCESS],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Cliquez sur le bonhomme en bas à gauche'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_MDP/FR_MDP_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Cliquez sur « Déconnexion »'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_MDP/FR_MDP_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Cliquez sur « Mot de passe oublié ? »'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_MDP/FR_MDP_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '4.',
    value: 'Renseigner votre adresse email puis cliquez sur « Soumettre »'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_MDP/FR_MDP_4.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '5.',
    value: 'Allez sur votre boite email et cliquez sur le lien « Réinitialiser le mot de passe »'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '6.',
    value: 'Définissez votre nouveau mot de passe'
  }]
};
